import { ClientActionTypes } from './constants';

const GET_VENDOR_DATA_INITIAL_STATE = {
    vendorData: [],
    loading: false,
};
const CREATE_VENDOR_DATA_INITIAL_STATE = {
    createVendorData: [],
    loading: false,
};
const UPDATE_VENDOR_DATA_INITIAL_STATE = {
    updateVendorData: null,
    loading: false,
};
const DELETE_VENDOR_DATA_INITIAL_STATE = {
    deleteVendorData: null,
    loading: false,
};

const GET_ACCOUNT_DATA_INITIAL_STATE = {
    accountData: [],
    loading: false,
};
const CREATE_ACCOUNT_DATA_INITIAL_STATE = {
    createAccountData: [],
    loading: false,
};
const UPDATE_ACCOUNT_DATA_INITIAL_STATE = {
    updateAccountData: null,
    loading: false,
};
const DELETE_ACCOUNT_DATA_INITIAL_STATE = {
    deleteAccountData: null,
    loading: false,
};
const UPLOAD_ACCOUNT_DATA_INITIAL_STATE = {
    uploadAccountData: null,
    loading: false,
};
const UPLOAD_CLIENT_DATA_INITIAL_STATE = {
    uploadClientData: null,
    loading: false,
};

const vendorDataReducer = (state = GET_VENDOR_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.VENDOR_DATA_LOADING:
            return {
                vendorData: state.vendorData,
                loading: true,
            };
        case ClientActionTypes.VENDOR_DATA_SUCCESS:
            return {
                vendorData: action.payload,
                loading: false,
            };
        case ClientActionTypes.VENDOR_DATA_ERROR:
            return {
                vendorData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
const createVendorDataReducer = (state = CREATE_VENDOR_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.CREATE_VENDOR_DATA_LOADING:
            return {
                createVendorData: state.createVendorData,
                loading: true,
            };
        case ClientActionTypes.CREATE_VENDOR_DATA_SUCCESS:
            return {
                createVendorData: action.payload,
                loading: false,
            };
        case ClientActionTypes.CREATE_VENDOR_DATA_ERROR:
            return {
                createVendorData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...CREATE_VENDOR_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};
const updateVendorDataReducer = (state = UPDATE_VENDOR_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.UPDATE_VENDOR_DATA_LOADING:
            return {
                loading: true,
            };
        case ClientActionTypes.UPDATE_VENDOR_DATA_SUCCESS:
            return {
                updateVendorData: action.payload,
                loading: false,
            };
        case ClientActionTypes.UPDATE_VENDOR_DATA_ERROR:
            return {
                updateVendorData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...UPDATE_VENDOR_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};
const deleteVendorDataReducer = (state = DELETE_VENDOR_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.DELETE_VENDOR_DATA_LOADING:
            return {
                deleteVendorData: action.payload,
                loading: true,
            };
        case ClientActionTypes.DELETE_VENDOR_DATA_SUCCESS:
            return {
                deleteVendorData: action.payload,
                loading: false,
            };
        case ClientActionTypes.DELETE_VENDOR_DATA_ERROR:
            return {
                deleteVendorData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...DELETE_VENDOR_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};
const uploadClientDataReducer = (state = UPLOAD_CLIENT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.UPLOAD_CLIENT_DATA_LOADING:
            return {
                uploadClientData: action.payload,
                loading: true,
            };
        case ClientActionTypes.UPLOAD_CLIENT_DATA_SUCCESS:
            return {
                uploadClientData: action.payload,
                loading: false,
            };
        case ClientActionTypes.UPLOAD_CLIENT_DATA_ERROR:
            return {
                uploadClientData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...UPLOAD_CLIENT_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};
// ------___________----___---_-_-_-___-_-_____-__-__-_-_____-___-__-___-_-_-_-_-_------__-__-_
const accountDataReducer = (state = GET_ACCOUNT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.ACCOUNT_DATA_LOADING:
            return {
                accountData: state.accountData,
                loading: true,
            };
        case ClientActionTypes.ACCOUNT_DATA_SUCCESS:
            return {
                accountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.ACCOUNT_DATA_ERROR:
            return {
                accountData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
const createAccountDataReducer = (state = CREATE_ACCOUNT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.CREATE_ACCOUNT_DATA_LOADING:
            return {
                createAccountData: state.createAccountData,
                loading: true,
            };
        case ClientActionTypes.CREATE_ACCOUNT_DATA_SUCCESS:
            return {
                createAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.CREATE_ACCOUNT_DATA_ERROR:
            return {
                createAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...CREATE_ACCOUNT_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};
const updateAccountDataReducer = (state = UPDATE_ACCOUNT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.UPDATE_ACCOUNT_DATA_LOADING:
            return {
                updateAccountData: action.payload,
                loading: true,
            };
        case ClientActionTypes.UPDATE_ACCOUNT_DATA_SUCCESS:
            return {
                updateAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.UPDATE_ACCOUNT_DATA_ERROR:
            return {
                updateAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...UPDATE_ACCOUNT_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};
const deleteAccountDataReducer = (state = DELETE_ACCOUNT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.DELETE_ACCOUNT_DATA_LOADING:
            return {
                deleteAccountData: action.payload,
                loading: true,
            };
        case ClientActionTypes.DELETE_ACCOUNT_DATA_SUCCESS:
            return {
                deleteAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.DELETE_ACCOUNT_DATA_ERROR:
            return {
                deleteAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...DELETE_ACCOUNT_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};
const uploadAccountDataReducer = (state = UPLOAD_ACCOUNT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.UPLOAD_ACCOUNT_DATA_LOADING:
            return {
                uploadAccountData: action.payload,
                loading: true,
            };
        case ClientActionTypes.UPLOAD_ACCOUNT_DATA_SUCCESS:
            return {
                uploadAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.UPLOAD_ACCOUNT_DATA_ERROR:
            return {
                uploadAccountData: action.payload,
                loading: false,
            };
        case ClientActionTypes.STATE_EMPTY_FIRST:
            return {
                ...UPLOAD_ACCOUNT_DATA_INITIAL_STATE
            };
        default:
            return state;
    }
};

export {
    vendorDataReducer,
    createVendorDataReducer,
    updateVendorDataReducer,
    deleteVendorDataReducer,
    accountDataReducer,
    createAccountDataReducer,
    updateAccountDataReducer,
    deleteAccountDataReducer,
    uploadAccountDataReducer,
    uploadClientDataReducer
};
